import { createFileRoute } from '@tanstack/react-router'
import UsersContainer from 'User/containers/UsersContainer'

import { Guard } from './-guard'

export const Route = createFileRoute('/users')({
    component: () => (
        <Guard claims={['opus_user']}>
            <UsersContainer />
        </Guard>
    ),
})
